import { render, staticRenderFns } from "./SelectCampaignsModal.vue?vue&type=template&id=53ada670"
import script from "./SelectCampaignsModal.vue?vue&type=script&lang=js"
export * from "./SelectCampaignsModal.vue?vue&type=script&lang=js"
import style0 from "./SelectCampaignsModal.vue?vue&type=style&index=0&id=53ada670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports